module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/ReviewContent-86dd5d3febcb6ba5052320b4fa15ece2.png";